module.exports = __webpack_public_path__ + "images/emoji/clock9.4920b03dd6e5d5b04444.png";